import PropTypes from 'prop-types'
import { RdtRegulationTypes } from '../../models/rdt/rdt-regulation-types-enum'
import { availableRdtRuleRegulationOptionPropType } from './available-rdt-rule-regulation-option-prop-type'

/**
 * @typedef {Object} AvailableRdtRuleRegulation
 * @property {AvailableRdtRuleRegulationOption[]} [options] - Regulation options.
 * @property {string} [stringCode]                          - Translation string code for regulation type.
 * @property {string} [type]                                - Regulation type.
 */
export const availableRdtRuleRegulationPropType = PropTypes.shape({
    options: PropTypes.arrayOf(availableRdtRuleRegulationOptionPropType),
    stringCode: PropTypes.string,
    type: PropTypes.oneOf(Object.values(RdtRegulationTypes))
})
